import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  FaMapMarkerAlt, 
  FaPhoneAlt , 
  FaEnvelope, 
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
  FaHeart,
  FaArrowRight
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../../styles/footer.css';

// Import logo
import logo from '../../assets/sensible-academy-logo1.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const usefulLinks = [
    { label: 'Home', path: '/' },
    { label: 'Jobs', path: '/jobs' },
    { label: 'Courses', path: '/courses' },
    { label: 'Services', path: '/services' },
    { label: 'Internship', path: '/internship' },
    { label: 'Vocational Training', path: '/vocational-training' },
    { label: 'Certificate Verification', path: '/verify' },
  ];
  
  const services = [
    { name: 'Full Stack Web Development', path: '/courses/27' },
    { name: 'Python, Data Analytics', path: '/courses/26' },
    { name: 'Java', path: '/courses/25' },
    { name: 'PHP , MYSQL', path: '/courses/30' },
    { name: 'C++', path: '/courses/28' },
    { name: 'Android', path: '/courses/31' },
    { name: 'Data Structure', path: '/courses/29' },
  ];

  const socialLinks = [
    { icon: <FaFacebookF />, url: 'https://www.facebook.com/people/Sensible-Academy-New/100083380580703/', color: '#3b5998', label: 'Facebook' },
    { icon: <FaLinkedinIn />, url: 'https://www.linkedin.com/company/sensible-academy/', color: '#0077b5', label: 'LinkedIn' },
    { icon: <FaInstagram />, url: 'https://www.instagram.com/sensibleacademy2005/', color: '#e4405f', label: 'Instagram' },
    { icon: <FaYoutube />, url: 'https://www.youtube.com/@sensibleacademy', color: '#ff0000', label: 'YouTube' }
  ];

  return (
    <footer className="footer-main-wrapper">
      {/* Animated Background Elements */}
      <div className="footer-main-bg-animation">
        <div className="footer-main-floating-circle footer-main-circle-1"></div>
        <div className="footer-main-floating-circle footer-main-circle-2"></div>
        <div className="footer-main-floating-circle footer-main-circle-3"></div>
        <div className="footer-main-floating-circle footer-main-circle-4"></div>
        <div className="footer-main-grid-pattern"></div>
      </div>

      <Container className="footer-main-container">
        {/* Main Footer Content */}
        <Row className="footer-main-row">
          {/* Company Info */}
          <Col lg={4} md={6} className="footer-main-col footer-main-col-company">
            <div className="footer-main-logo-wrapper">
              <img src={logo} alt="Sensible Academy" className="footer-main-logo-img" />
            </div>
            <h5 className="footer-main-title footer-main-title-company">Sensible Academy</h5>
            <div className="footer-main-contact-info">
              <div className="footer-main-contact-item">
                <FaMapMarkerAlt className="footer-main-contact-icon" />
                <span>
                  B-492, Second Floor<br />
                  Junwani Main Road<br />
                  Smriti Nagar, Bhilai<br />
                  Chattisgarh
                </span>
              </div>
              <div className="footer-main-contact-item">
                <FaPhoneAlt  className="footer-main-contact-icon" />
                <a href="tel:+917722899444" className="footer-main-contact-link">+91 77228-99444 | +91 93013-51989</a>
              </div>
              <div className="footer-main-contact-item">
                <FaEnvelope className="footer-main-contact-icon" />
                <a href="mailto:contact@sensibleacademy.com" className="footer-main-contact-link">contact@sensibleacademy.com</a>
              </div>
            </div>
          </Col>

          {/* Useful Links */}
          <Col lg={2} md={6} className="footer-main-col footer-main-col-links">
            <h5 className="footer-main-title footer-main-title-links">Useful Links</h5>
            <ul className="footer-main-links-list">
              {usefulLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.path} className="footer-main-link">
                    <FaArrowRight className="footer-main-link-arrow" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Our Services */}
          <Col lg={3} md={6} className="footer-main-col footer-main-col-services">
            <h5 className="footer-main-title footer-main-title-services">premium courses</h5>
            <ul className="footer-main-services-list">
              {services.map((service, index) => (
                <li key={index}>
                  <Link to={service.path} className="footer-main-service-link">
                    <span className="footer-main-service-dot"></span>
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </Col>

          {/* Social Networks */}
          <Col lg={3} md={6} className="footer-main-col footer-main-col-social">
            <h5 className="footer-main-title footer-main-title-social">Our Social Networks</h5>
            <p className="footer-main-social-text">
              You can connect with us on social, to get information about internship, 
              job openings, valuable insights of programming world, premium courses, 
              free webinars and placement preparation training from experienced faculties.
            </p>
            <div className="footer-main-social-links">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-main-social-link"
                  aria-label={social.label}
                  style={{ '--footer-main-social-color': social.color }}
                >
                  {social.icon}
                  <span className="footer-main-social-tooltip">{social.label}</span>
                </a>
              ))}
            </div>
          </Col>
        </Row>

        {/* Copyright Section */}
        <Row className="footer-main-bottom">
          <Col className="text-center">
            <p className="footer-main-copyright">
              © Copyright <strong className="footer-main-copyright-brand">Sensible Computers</strong>. All Rights Reserved
              <br />
              <span className="footer-main-designed-by">
                Designed with <FaHeart className="footer-main-heart-icon" /> by{' '}
                <a 
                  href="https://sensible-computers.com/index.php" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-main-designer-link"
                >
                  Sensible Computers
                </a>
              </span>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;